<template>
    <el-dialog :visible.sync="dialogVisible" :width="width">
        <span>{{content}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">OK</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "InfoDialog",
        props: {
            width: {
                required: false,
                type: String,
                default: "30%"
            }
        },
        data() {
            return {
                dialogVisible: false,
                content: ""
            }
        },
        methods: {
            show(content){
                this.content = content;
                this.dialogVisible = true;
            }
        }
    }
</script>

<style scoped>

</style>